import { createFileRoute } from '@tanstack/react-router';
import { zodValidator } from '@tanstack/zod-adapter';

import { ChatProvider } from '@/components/Chat/ChatContext';
import { OrgDocLayout } from '@/components/OrgDocs/OrgDocLayout';
import { MemoryTunerProvider } from '@/contexts/MemoryTunerContext';
import { PageProvider } from '@/contexts/PageContext';
import { orgDocsSearchSchema } from '@/routes/$organizationName/org-docs/index';

export const Route = createFileRoute('/$organizationName/org-docs/$pageVersionNodeId')({
  component: OrgDocPage,
  validateSearch: zodValidator(orgDocsSearchSchema.partial()),
});

function OrgDocPage() {
  const { organizationName, pageVersionNodeId } = Route.useParams();
  const backSearch = Route.useSearch();

  return (
    <PageProvider pageVersionNodeId={pageVersionNodeId}>
      <MemoryTunerProvider>
        <ChatProvider>
          <OrgDocLayout
            backSearch={backSearch}
            organizationName={organizationName}
            pageVersionNodeId={pageVersionNodeId}
          />
        </ChatProvider>
      </MemoryTunerProvider>
    </PageProvider>
  );
}
